import {
    all,
    fork,
    take,
    cancelled,
    takeLatest,
    race,
    put,
    call
} from 'redux-saga/effects';

import { LOGOUT_USER, SET_ACTIVE_USER_ORG, GET_ORG_OTC_CODES } from '../actions/types';

import { eventChannel } from 'redux-saga';

import { getOtcCodesSuccess } from '../actions/Otc';

import { db } from 'config/firebase';

import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { log } from 'utils/Loggers';

const otcCollectionRef = collection(db, 'otc');

//////////////// Get User Organization ////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////// OTC Codes Collection /////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function* otcCollectionWatch(orgId, property_id) {
    let unsubscribeOtcData;

    const otcCollectionQuery = query(
        otcCollectionRef,
        where('org_id', '==', orgId),
        where('property_id', '==', property_id),
        where('status', '==', 'active')
    );

    const otcCollectionChannel = eventChannel(emit => {
        unsubscribeOtcData = onSnapshot(otcCollectionQuery, querySnapshot => {
            const codes = [];
            if (!querySnapshot.empty) {
                querySnapshot.docs.forEach(doc => {
                    codes.push(doc.data());
                });
            }
            emit(codes);
        });

        return () => {
            if (unsubscribeOtcData) {
                unsubscribeOtcData();
            }
        };
    });

    try {
        while (true) {
            const { userSignOut, resettingOrg, orgCodesData } = yield race({
                userSignOut: take(LOGOUT_USER),
                resettingOrg: take(SET_ACTIVE_USER_ORG),
                orgCodesData: take(otcCollectionChannel)
            });

            if (userSignOut) {
                yield call([otcCollectionChannel, 'close']);
            } else if (resettingOrg) {
                otcCollectionChannel.close();
            } else {
                const codes = orgCodesData.length ? orgCodesData : { exists: false };
                yield put(getOtcCodesSuccess(codes));
            }
        }
    } catch (error) {
        log('OTC Error: getting org codes collection data (FS)', {
            error,
            orgId,
            property_id
        });
    } finally {
        if (unsubscribeOtcData) yield call(unsubscribeOtcData);
        if (yield cancelled()) {
            yield call([otcCollectionChannel, 'close']);
            if (unsubscribeOtcData) yield call(unsubscribeOtcData);
        }
    }
}

///////////// Action Creators For Root Saga //////////////////

export function* getOtcCodes() {
    yield takeLatest(GET_ORG_OTC_CODES, otcCollectionWatch);
}

export default function* rootSaga() {
    yield all([fork(getOtcCodes)]);
}
